<template>
    <div v-if="$store.state.isModalOpenTwo" class="modal fade show" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-dialog-centered" ref="modalRef">
            <div class="modal-content p-2">
                <div v-for="(item, index) in moneyReceiptData" :key="index">
                    <div class="d-flex justify-content-center align-items-center p-1">
                        <span class="text-center">{{ item.voucher_no }}</span>
                        <button class="btn btn-secondary btn-sm curosr-pointer mx-1"
                            @click="goToPrint(item.id)"
                        >
                            <i class="fas fa-print"></i>
                        </button>
                    </div>
                </div>

                <div class="col-12 text-center mt-2">
                    <button @click.prevent="onClickClose" class="btn btn-outline-secondary waves-effect">
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, inject } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from 'vue-router';
import handlePurchase from "@/services/modules/purchase";
import moneyReceiptHelper from "@/services/utils/pdf/dental/moneyReceiptHelper";

const props = defineProps(['moneyReceiptData', 'companyInfo']);
const $store = useStore();
const $route = useRoute();
const $router = useRouter();
const modalRef = ref(null);
const showError = inject('showError');
const { fetchMoneyReceipt } = handlePurchase();
const { generatePdf } = moneyReceiptHelper();
const moneyReceipt = ref({});

const onClickClose = () => {
    $store.state.isModalOpenTwo = false;
}

const goToPrint = async (id) => {
    const companyQuery = `?company_id=${$route.params.companyId}`;

    try {
        const res = await fetchMoneyReceipt(id, companyQuery);
        if (!res.status) {
            return;
        }
        moneyReceipt.value = res.data;
        generatePdf(props.companyInfo, moneyReceipt.value);
    } catch (e) {
        showError('Something is wrong. Check your connectivity!!');
    }
}
</script>
